<app-content-layout-wrapper>
  <div class="flex flex-column justify-content-center flex-grow-1">
    <div class="title">
      {{ 'PAGE_NOT_FOUND.TITLE' | translate }}
    </div>
    <div class="sub-title">
      <b> {{ 'PAGE_NOT_FOUND.MESSAGE' | translate }} </b>
      <div class="mail">
        <a href="mailto: support@payme.io">support@payme.io</a>
      </div>
    </div>
    <div class="flex justify-content-center">
      <img src="../../../../assets/images/not-found.svg" />
    </div>
  </div>
</app-content-layout-wrapper>
